
export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
              Your Local El Paso Cash Home Buyers
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              We Buy Houses in <strong>Any Condition</strong> Throughout El Paso
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              TRex RE LLC has been helping El Paso homeowners sell their properties quickly since 2016. Whether you're <a href="/avoid-foreclosure" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">facing foreclosure</a>, dealing with an <a href="/inherited-homes" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">inherited property</a>, own a <a href="/sell-distressed-property" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">distressed home</a>, or have <a href="/title-issues" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">title issues</a>, we provide fair cash offers and close on your timeline.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              As local investors who live and work in El Paso, we understand the unique challenges homeowners face in our community. From the historic neighborhoods of Central El Paso to the growing communities in the Northeast, we buy properties in every area of the Sun City. We also help landlords <a href="/rental-property" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">sell rental properties</a> and purchase <a href="/land-buyers" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">vacant land</a> throughout the region.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Unlike wholesalers who put your property under contract and then shop it around, we are the actual end buyers. This means faster closings, more certainty, and a smoother transaction from start to finish. Stay informed about the local market by visiting our <a href="/local-news-el-paso-texas" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso news and information</a> section.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="/get-cash-offer-for-my-property" className="inline-flex items-center space-x-2 px-8 py-4 bg-teal-600 text-white rounded-lg font-bold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                <span>Get Your Cash Offer</span>
                <i className="ri-arrow-right-line"></i>
              </a>
              <a href="tel:+1-915-206-5814" className="inline-flex items-center space-x-2 px-8 py-4 border-2 border-teal-600 text-teal-600 rounded-lg font-bold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill"></i>
                <span>(915) 206-5814</span>
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/ec6e1907903823be970cddb977fd06ff.jpg"
                alt="El Paso Cash Home Buyers Meeting with Homeowner"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-8 rounded-xl shadow-xl">
              <div className="text-5xl font-bold mb-1">500+</div>
              <div className="text-sm font-medium">El Paso Homes Purchased</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
